webpackJsonp([95015380831008],{

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/viljapelto2-490x368-2256.ad76bcca.jpg";

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(34);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _layouts = __webpack_require__(20);
	
	var _SideBarRight = __webpack_require__(58);
	
	var _SideBarRight2 = _interopRequireDefault(_SideBarRight);
	
	var _viljapelto2490x = __webpack_require__(857);
	
	var _viljapelto2490x2 = _interopRequireDefault(_viljapelto2490x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Psykoterapia = function (_React$Component) {
	  _inherits(Psykoterapia, _React$Component);
	
	  function Psykoterapia() {
	    _classCallCheck(this, Psykoterapia);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Psykoterapia.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Kirsti Louko - Ty\xF6nohjaus'
	        )
	      ),
	      _react2.default.createElement(
	        _layouts.PageTop,
	        null,
	        _react2.default.createElement(
	          _layouts.TitleH1,
	          null,
	          'TY\xD6NOHJAUS'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Ty\xF6nohjaus on oman ty\xF6n tutkimista, arviointia ja kehitt\xE4mist\xE4, joka tapahtuu koulutetun ty\xF6nohjaajan avulla.\u200B\u200B'
	        )
	      ),
	      _react2.default.createElement(
	        _layouts.Content,
	        null,
	        _react2.default.createElement(_SideBarRight2.default, { view: 'tyonohjaus' }),
	        _react2.default.createElement(
	          _layouts.Main,
	          { column: true },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ty\xF6nohjaus on ty\xF6h\xF6n, ty\xF6yhteis\xF6\xF6n ja omaan ty\xF6rooliin liittyvien kysymysten, kokemusten ja tunteiden yhdess\xE4 tulkitsemista ja j\xE4sent\xE4mist\xE4.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ty\xF6nohjauksessa ohjattava pohtii suhdetta ty\xF6h\xF6ns\xE4. Ohjaaja ja mahdolliset muut osallistujat auttavat ohjattavaa n\xE4kem\xE4\xE4n itsens\xE4 ja ty\xF6ns\xE4 entist\xE4 tarkemmin ja selvemmin.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ty\xF6nohjaus on vuorovaikutusta, jossa sek\xE4 ohjaaja ett\xE4 ohjattavat oppivat toisiltaan.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ty\xF6nohjaus auttaa jaksamaan ty\xF6ss\xE4 ja pysym\xE4\xE4n ty\xF6kykyisen\xE4.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ty\xF6nohjauksessa k\xE4yt\xE4n ratkaisukeskeisi\xE4 menetelmi\xE4. Ty\xF6nohjaus r\xE4\xE4t\xE4l\xF6id\xE4\xE4n asiakkaan tarpeenmukaisesti.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Hinnat sovitaan asiakkaan kanssa toimeksiannon laajuudesta riippuen.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement('img', { src: _viljapelto2490x2.default })
	          )
	        )
	      )
	    );
	  };
	
	  return Psykoterapia;
	}(_react2.default.Component);
	
	exports.default = Psykoterapia;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tyonohjaus-js-67657ff6223229e975e5.js